import { ORDER_BY } from "~/common/constants";

export const PATIENT_SEARCH_TABLE_COLUMN_IDS = {
  name: "name",
  consultationStatus: "consultationStatus",
  primaryProvider: "primaryProvider",
  state: "state",
  engagement: "engagement",
} as const;

export type PatientSearchTableColumnId =
  (typeof PATIENT_SEARCH_TABLE_COLUMN_IDS)[keyof typeof PATIENT_SEARCH_TABLE_COLUMN_IDS];

export const COLUMN_ID_TO_ORDER_BY: Record<
  PatientSearchTableColumnId,
  (typeof ORDER_BY)[keyof typeof ORDER_BY]
> = {
  [PATIENT_SEARCH_TABLE_COLUMN_IDS.name]: ORDER_BY.lastName,
  [PATIENT_SEARCH_TABLE_COLUMN_IDS.consultationStatus]:
    ORDER_BY.consultationStatus,
  [PATIENT_SEARCH_TABLE_COLUMN_IDS.primaryProvider]: ORDER_BY.provider,
  [PATIENT_SEARCH_TABLE_COLUMN_IDS.state]: ORDER_BY.state,
  [PATIENT_SEARCH_TABLE_COLUMN_IDS.engagement]: ORDER_BY.engagement,
};

const orderByToColumnId = Object.entries(COLUMN_ID_TO_ORDER_BY).map(
  ([columnId, orderBy]) => [orderBy, columnId] as const,
);

export const ORDER_BY_TO_COLUMN_ID = Object.fromEntries(
  orderByToColumnId,
) as Record<string, PatientSearchTableColumnId>;

export const getOrderByFromColumnId = (
  columnId: string,
): (typeof ORDER_BY)[keyof typeof ORDER_BY] | undefined =>
  COLUMN_ID_TO_ORDER_BY[columnId as PatientSearchTableColumnId];

export const getColumnIdFromOrderBy = (
  orderBy: string,
): PatientSearchTableColumnId | undefined => ORDER_BY_TO_COLUMN_ID[orderBy];
